import { render } from "./CenterComp.vue?vue&type=template&id=bfc3f01e"
import script from "./CenterComp.vue?vue&type=script&lang=js"
export * from "./CenterComp.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__